import React, { useRef, useState, useEffect } from 'react';
import Uploader from '../Uploader/Uploader';
import Dropbox from '../Dropbox';
import FileList from '../FileList';
import { useDispatch, useSelector } from 'react-redux';
import { useHelpers } from 'hooks';
import * as OrderActions from 'store/order/orderSlice';
import * as OrderSelectors from 'store/order/orderSelectors';
import * as Utils from 'utils';
import FieldCheckbox from "../FieldCheckbox";

let fileIsProcessing = false;
let fileCurrentIsProcessing;
let files = [];

export default function FormControlUploadFiles() {
  const dispatch = useDispatch();
  const dropboxRef = useRef();
  const {mergeArrayByProp} = useHelpers();
  const fileUploadRef = useRef();
  const checkboxFileLoadingProcessing = useRef();
  const [fileUploadAmazonOptions, setFileUploadAmazonOptions] = useState({
    acl: 'public-read',
    success_action_status: '201',
    Filename: '',
    AWSAccessKeyId: window.serviceList.amazon.accessKey,
    Policy: window.serviceList.amazon.policy,
    Signature: window.serviceList.amazon.signature,
    'Content-Type': '',
  });

  const dropboxFiles = useSelector(OrderSelectors.selectAttachmentsDropbox);
  const amazonFiles = useSelector(OrderSelectors.selectAttachmentsAmazon);

  const findFirstFileForUploading = () => {
    const fileIndex = files.findIndex(file => file.status === 'inited');

    if (fileIndex > -1) {
      const file = files[fileIndex];
      const fileName = file.blobFile.name;
      const fileType = file.blobFile.type;
      const fileKey = Utils.randomHash() + '-' + file.blobFile.name;

      setFileUploadAmazonOptions({
        ...fileUploadAmazonOptions,
        Filename: fileName,
        'Content-Type': fileType,
        key: fileKey
      });

      return files[fileIndex];
    }

    return false;
  };

  const fileStartUpload = () => {
    let file;

    if (fileIsProcessing) {
      return false;
    }

    file = findFirstFileForUploading();

    if (file) {
      setTimeout(() => {
        fileIsProcessing = true;
        onChangeFileLoading();
        fileCurrentIsProcessing = file.fileKey;
        fileUploadRef.current.start(file);
      },100);
    }
  };

  const onFileChange = (filesList) => {
    files = mergeArrayByProp(files, filesList, 'fileKey');
    fileStartUpload();
    onChangeFileLoading();
  };

  const onFileRemove = (file) => {
    const currentFile = files.find(f => f.fileKey === file.fileKey);
    const currentFileHash = currentFile?.amazon?.hash || null;
    files = files.filter(f => f.fileKey !== file.fileKey);
    dispatch(OrderActions.deleteFileAmazonByHash(currentFileHash));

    if (file.fileKey === fileCurrentIsProcessing) {
      fileIsProcessing = false;
      fileCurrentIsProcessing = undefined;
      onChangeFileLoading();
    }
  };

  const onFileSuccess = (response, currentFile) => {
    const currentFileIndex = files.findIndex(file => file.fileKey === currentFile.fileKey);
    const amazonResponse = Utils.xmlToJson(response)?.PostResponse || {};
    const hash = Utils.randomHash();

    fileIsProcessing = false;
    onChangeFileLoading();
    files[currentFileIndex] = {
      ...files[currentFileIndex],
      status: 'finished',
      amazon: {
        hash,
        name: files[currentFileIndex].blobFile.name,
        type: files[currentFileIndex].blobFile.type,
        size: files[currentFileIndex].blobFile.size,
        destination: amazonResponse?.Location || '',
      }
    };
    fileStartUpload();
    dispatch(OrderActions.setOrderAttachmentsAmazon(files.map(file => file.amazon)));
  };

  useEffect(() => {
    return () => {
      fileIsProcessing = false;
      onChangeFileLoading();
      files = [];
    };
  }, []);

  const onCreateFilesDropbox = (files) => {
    dispatch(OrderActions.createFilesDropbox(files));
  };

  const onDeleteFileDropboxByHash = (hash) => {
    dispatch(OrderActions.deleteFileDropboxByHash(hash));
  };

  const onDeleteFileAmazonByHash = (hash) => {
    dispatch(OrderActions.deleteFileAmazonByHash(hash));
  };

  const onChangeFileLoading = () => {
    if (checkboxFileLoadingProcessing.current?.querySelector(`input[name="isFileLoadingProcessing"]`).checked != fileIsProcessing) {
      checkboxFileLoadingProcessing.current?.querySelector(`input[name="isFileLoadingProcessing"]`).click();
    }
  };

  return (
    <>
      <Uploader
        action={window.serviceList.amazon.bucketUri}
        autoUpload={false}
        onChange={onFileChange}
        onSuccess={onFileSuccess}
        onRemove={onFileRemove}
        ref={fileUploadRef}
        data={fileUploadAmazonOptions}
        multiple
        draggable className="app-uploader">
        <div>
          <div className="app-uploader-text">
            Drop files here to upload or <span className="app-uploader-link">choose file</span><br/>
            <span onClick={dropboxRef.current?.choose} className="app-uploader-dropbox">Dropbox</span>
          </div>
        </div>
      </Uploader>
      <FileList
        files={amazonFiles}
        onDeleteByHash={onDeleteFileAmazonByHash}
      />
      <Dropbox
        ref={dropboxRef}
        files={dropboxFiles}
        onCreateFiles={onCreateFilesDropbox}
        onDeleteFileByHash={onDeleteFileDropboxByHash}
      />
      <FieldCheckbox
          ref={checkboxFileLoadingProcessing}
          name="isFileLoadingProcessing"
          checked={fileIsProcessing}
          value={fileIsProcessing}
          style={{display: 'none'}}
      />
    </>
  )
}
